import { Chip } from 'components'

export const data = [
  { value: 1, label: 'Meditator', chip: 'M' },
  { value: 2, label: 'Sidha', chip: 'S' },
  { value: 3, label: 'Teacher', chip: 'T' },
]

export const getTMLevel = (input: number | undefined) => {
  return data.find((level) => level.value === input)
}

export const TMLevelChip = ({ level }: { level?: number }) => {
  const label = getTMLevel(level)?.chip
  return label ? (
    <Chip data-cy="tm-level-chip" variant="TMLevel" label={label} />
  ) : null
}
